import { memo } from "react";

//Following Page is just a layout page which will appear if live stream is Accessed in Web from iPhone/iPad
function JoinLiveStreamApp() {
  return (
    <div id="divVagaroCustAppDownload">
      <div className="livestream-download-wrapper">
        <div className="app-header">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <img
                  src="https://vagaro.azureedge.net/static-content/PublicImages/Images/vagaro-logo-new.svg"
                  className="img-responsive top-logo-app-img"
                  title="Vagaro"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <section className="section-bottom vagarowrapper">
          <div className="section-bottom-inner">
            <div className="container">
              <div className="row">
                <div className="col-md-12 text-center">
                  <div className="sectioncontent">
                    <div className="logo-center text-center">
                      <div className="appicon text-center">
                        <img
                          src="https://vagaro.azureedge.net/static-content/Images/v-logo.svg"
                          className="img-responsive app-icon"
                          title="Vagaro"
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="app-descriptionmain">
                      <div className="app-description">
                        Join Live Stream Sessions with the Vagaro App
                      </div>
                    </div>
                    <div className="app-button">
                      <div
                        className="vagaro-container vagaro-embedded-widget"
                        id="iOS"
                      >
                        <div className="vagaro-noniframe">
                          <div className="vagaro-download flamingo-primary text-white">
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href="http://itunes.apple.com/app/vagaro/id536110000?mt=8"
                              title="Download Vagaro"
                              onclick="_vgLiveStream.ClipBoardLink()"
                            >
                              <div className="iOS">
                                <div>Download Vagaro</div>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="app-description subtxt">
                      Or you can login to your account on a desktop web browser
                      to join your appointment without the app.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
export default memo(JoinLiveStreamApp);
